import { render, staticRenderFns } from "./TreeConfigModal.vue?vue&type=template&id=7af52ec0"
import script from "./TreeConfigModal.vue?vue&type=script&lang=js"
export * from "./TreeConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports